import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { DeleteOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { reload, loadPage, deleteInvitation } from "../registrationSlice";
import { loadRoles } from "../../users/usersSlice";
import PendingRole from "../../../components/tables/PendingRole";
import { resendInvite } from "../registrationSlice";
import Actions from "../../../components/tables/Actions";
import PendingBranches from "../../../components/tables/PendingBranches";
import Date from "../../../components/tables/Date";
import moment from "moment";
import "moment/locale/he";
import { ReactComponent as InvitationsImg } from "../../../assets/no-invitation.svg";
import ActionsTable from "../../../components/templates/ActionsTable";

const PendingInvitations = () => {
  const dispatch = useDispatch();
  const { page: registrationPage } = useSelector((state) => state.registration);
  const { current, pageSize, total, order, items, filter } = registrationPage;
  const loading = useSelector(
    (state) => state.pendingActions["registration/loadPage"]
  );
  const resendLoading = useSelector(
    (state) => state.pendingActions["registration/resendInvitation"]
  );
  const [convertedItems, setConvertedItems] = useState([]);
  const [activeId, setActiveId] = useState(null);

  const intl = useIntl();

  useEffect(() => {
    dispatch(loadRoles());
    moment.locale("he");
  }, [dispatch]);

  useEffect(() => {
    setConvertedItems(items);
  }, [items]);

  const onDeleteConfirmed = (id) => {
    return dispatch(deleteInvitation(id));
  };

  const onTextChange = (e) => {
    dispatch(
      loadPage({ current: 1, filter: { ...filter, freeText: e.target.value } })
    );
  };

  const onResendInvitation = async (record) => {
    const invite = items.filter(
      (item) => item.phone_number === record.phone_number
    )[0];
    const branches =
      invite && invite["branches"]
        ? invite["branches"].map((branches) => branches["id"])
        : [];
    if (invite) {
      setActiveId(invite.id);
      const action = await dispatch(resendInvite({ ...invite, branches }));
      if (!action.error) {
        dispatch(reload());
      }
    }
  };

  return (
    <ActionsTable
      borderless={true}
      tableItems={[
        {
          title: "name",
          responsive: ["md"],
          sortIndex: "name",
          sorter: true,
        },
        { title: "user_name", responsive: ["md"] },
        { title: "phone_number", responsive: ["xl"] },
        {
          title: "role_id",
          responsive: ["xl"],
          width: 140,
          render: PendingRole,
        },
        { title: "branches", responsive: ["xxl"], render: PendingBranches },
        {
          title: "expired_at",
          responsive: ["md"],
          render: Date,
          columnProps: { format: "L" },
        },
        {
          title: "actions",
          responsive: ["md"],
          render: Actions,
          columnProps: {
            firstLoading: resendLoading,
            activeId: activeId,
            onFirstClicked: onResendInvitation,
            onDeleteConfirmed: onDeleteConfirmed,
            dangerActionText: "delete",
            firstActionText: "resend",
            category: "registration",
          },
        },
      ]}
      ltrItems={["phone_number"]}
      category={"registration"}
      actions={true}
      onFirstClicked={onResendInvitation}
      firstActionIcon={<FormattedMessage id="app.actions.resend" />}
      onDeleteConfirmed={onDeleteConfirmed}
      dangerActionIcon={<DeleteOutlined />}
      current={current}
      pageSize={pageSize}
      total={total}
      loading={loading}
      textFilter={filter.freeText}
      reload={reload}
      loadPage={loadPage}
      onTextChange={onTextChange}
      items={convertedItems}
      headerInputPlaceholder={intl.formatMessage({
        id: "app.users.typeUserName",
      })}
      showheader={true}
      inputStyle={300}
      emptyImage={<InvitationsImg />}
      emptytext={<FormattedMessage id="app.tables.noInvitations" />}
    />
  );
};

export default PendingInvitations;
